import createValidator from 'typecheck.macro';
import { makeExperimentWithData } from '../ExperimentContext/types';

export const AnnouncementBannerExperiment = makeExperimentWithData(
  'announcement-banner',
  createValidator<
    | undefined
    | {
        title: string;
        cta: string;
        ctaLink: string;
        specialty?: { include?: [string]; exclude?: [string] };
      }
  >(),
);

export const AnnouncementBannerExperimentProfiles = (
  isPublishingFluVax: string,
  isPublishing: string,
  isPublishingCovidVax: string,
  specialty: string,
) =>
  makeExperimentWithData(
    'announcement-banner-profile',
    createValidator<
      | undefined
      | {
          title: string;
          cta: string;
          ctaLink: string;
          specialty?: { include?: [string]; exclude?: [string] };
        }
    >(),
    {
      isPublishingFluVaxAppointments: isPublishingFluVax,
      isPublishing: isPublishing,
      isPublishingCovidAppointments: isPublishingCovidVax,
      practiceProfilePracticeSpecialty: specialty,
    },
  );
